<template>
  <div>
    <v-autocomplete
      clearable
      :label="$t('Bill-Type')"
      :items="items"
      item-text="RecieptTypeName"
      item-value="ID"
      v-model="val"
      :rules="rules"
      return-object
    >
    </v-autocomplete>
  </div>
</template>

<script>
import auth from "@/api/auth";

export default {
  props: {
    value: {},
    rules: {
      typeof: Array,
      default: [],
    },
    isCoper:{
      type:Boolean,
      default:false
    },
    coperDate:{
    }
  },
  computed: {
    val: {
      get: function () {
        if (this.value=='undefined')
        {
          return null;
        }
        return this.value;
      },
      set: function (newValue) {
        if (newValue=='undefined')
        {
          newValue=null;
        }
       
        this.$emit("input", newValue);
      },
    },
  },
  data() {
    return {
      loading: false,
      searchFisTipi: null,
      items: [],
      credentials: JSON.parse(window.localStorage.getItem("credentials")),
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true;
     
      
      var params = {};
      if(this.isCoper == true){
      let coperParams = {
        Coper : true,
        CoperTarih : this.coperDate,
        CompanyID : this.credentials.CoperSirketNo
      };

       params = coperParams;
      }else{
        params = null;
      }

      this.$http
        .post(
          auth.API_URL + "api/AccountingDefinitions/RecieptTypeList",
          params,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            this.items = response.body;
            this.loading = false;
          },
          (response) => {
            if (response.status === 0) {
              this.loading = false;
              this.text1 = "Service Unavailable";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable";
              this.loading = false;
              this.snackbar = true;
            }
          }
        );
    },
  },
};
</script>

<style>
</style>